import React, { useState } from "react";
import {
  HeaderContainer,
  LogoText,
  NavLinks,
  NavLink,
  HamburgerMenu,
  MobileNavLinks,
  MobileNavLink,
} from "../Styles/StylesHeader";

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogoClick = () => {
    // Delay the page refresh by 2 seconds
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <HeaderContainer>
      {/* Logo Text */}
      <LogoText onClick={handleLogoClick}>EnjoyEstate</LogoText>

      {/* Hamburger Menu for Mobile */}
      <HamburgerMenu onClick={toggleMobileMenu} className="lg:hidden">
        {isMobileMenuOpen ? "✖" : "☰"}
      </HamburgerMenu>

      {/* Desktop Navigation */}
      <NavLinks className="hidden lg:flex space-x-6">
        <NavLink href="/">Home</NavLink> {/* Home Button Added */}
        <NavLink href="/real-estate-reports">Real Estate Reports</NavLink>
        <NavLink href="/podcasts">Podcasts</NavLink>
        <NavLink href="/blog">Blog</NavLink>
        <NavLink href="/about">About</NavLink>
      </NavLinks>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <MobileNavLinks className="lg:hidden">
          <MobileNavLink href="/">Home</MobileNavLink> {/* Home Button Added */}
          <MobileNavLink href="/real-estate-reports">
            Real Estate Reports
          </MobileNavLink>
          <MobileNavLink href="/podcasts">Podcasts</MobileNavLink>
          <MobileNavLink href="/blog">Blog</MobileNavLink>
          <MobileNavLink href="/about">About</MobileNavLink>
        </MobileNavLinks>
      )}
    </HeaderContainer>
  );
}

export default Header;
